import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PageLoader } from 'apps/shared/scripts/components';

import { useLogoutUser } from '../../hooks';

const LogoutContainer = () => {
  const { isLoading, logout } = useLogoutUser();
  const [searchParams] = useSearchParams();
  const referrer = searchParams.get('r');

  useEffect(() => {
    logout();
  }, [logout]);

  useEffect(() => {
    if (!isLoading) {
      const redirectTo = referrer ? `/${referrer}` : '/';
      window.location.replace(redirectTo);
    }
  }, [isLoading, referrer]);

  return <PageLoader />;
};

LogoutContainer.displayName = 'LogoutContainer';

export default LogoutContainer;
